import { useRef, useEffect } from 'react'
import * as THREE from 'three'
import { useSpring, a } from '@react-spring/three'

export default function Fragments(props)
{
    const count = props.count
    const instancedFragments = useRef(null)
    const fragment = new THREE.Object3D()

    const [spring, api] = useSpring(() => ({ scale: [.5, .5, .5], config: { mass: 1, tension: 10 } }), [])

    useEffect(() =>
    {
        // Set positions
        for (let i = 0; i < count; i++)
        {
            fragment.position.set(
                (Math.random() - 0.5) * 7,
                (Math.random() - 0.5) * 4,
                (Math.random() - 0.5) * 4
            )
            const randomScale = 0.02 + (Math.random() * 0.8)
            fragment.scale.set(randomScale, randomScale, randomScale)
            fragment.rotation.set(Math.PI * Math.random(), Math.PI * Math.random(), 0)

            fragment.updateMatrix()
            instancedFragments.current.setMatrixAt(i, fragment.matrix)
        }

        // Update the instance
        instancedFragments.current.instanceMatrix.needsUpdate = true
        const scale = () =>
        {
            api.start({ scale: [1, 1, 1] })
        }

        setTimeout(scale, props.delay * 1000)
    }, [])



    return (
        <>
            <a.instancedMesh {...spring} ref={instancedFragments} args={[null, null, count]}>
                <octahedronGeometry args={[0.05, 0]} />
                <meshStandardMaterial color="#8f7247" />
            </a.instancedMesh>
        </>
    )
}